
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#bac1cc","data-name":"vuesax/bulk/bag-2"}},[_c('path',{attrs:{"d":"M18.888 10.337a.812.812 0 01-.817-.817V8.031a4.066 4.066 0 00-4.468-4.052 4.388 4.388 0 00-3.675 4.258v1.05a.812.812 0 01-.817.817.812.812 0 01-.816-.817v-1.05a6.015 6.015 0 015.145-5.88 5.706 5.706 0 016.255 5.674V9.52a.809.809 0 01-.807.817z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M23.283 10.453c-.976-1.085-2.586-1.61-4.943-1.61H9.66c-2.356 0-3.966.525-4.946 1.61a5.13 5.13 0 00-.969 4.107l.817 6.5c.245 2.275 1.167 4.608 6.183 4.608h6.51c5.017 0 5.938-2.333 6.183-4.6l.817-6.522a5.159 5.159 0 00-.972-4.093zm-13.459 4.89h-.012a1.173 1.173 0 11.012 0zm8.167 0h-.008a1.173 1.173 0 11.012 0z","opacity":".4"}})])])
          )
        }
      }
    